import {ApolloLink} from '@apollo/client';
import removeDirectives from 'src/internal/shared/utils/removeDirectives';

import type {InternalOperation} from 'src/types';

export default function createDirectivesToContextLink(): ApolloLink {
  return new ApolloLink(function directivesToContextLink(
    operation: InternalOperation,
    forward,
  ) {
    const {gql, directives} = removeDirectives(operation.query);

    const overriddenContext: ReturnType<InternalOperation['getContext']> = {};

    if (directives.tag) {
      overriddenContext.queryTag = directives.tag;
    }

    if (directives.hash) {
      overriddenContext.operationHash = directives.hash;
    }

    operation.query = gql;

    operation.setContext(overriddenContext);

    return forward(operation);
  });
}
